import {
  BeibehaltenData,
  Dokument as BffDokument,
  DokumentenErstellungRequestModel,
  EuBPDruckdaten,
  InfopaketDruckdaten,
  SparteDruckdaten,
  Vertragsschlussverfahren,
} from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { getTarifbereich } from '@ps20-frontend/frontend-models';
import { convertDateFormatFromLocalStateToShortIso } from '@ps20-frontend/utils';
import { getProgrammteilnahme } from '../../model/policeVersandArt';
import { IAppState } from '../../localStore';
import { getBeziehungVpZumVn } from '../druckenSaga.helper';
import {
  addCheckoutDataToSparteDruckdaten,
  mapAntraege,
  mapBankverbindung,
  mapBeratungDruck,
  mapTelefonverkauf,
  mapVermittler,
  mapVersicherungsnehmer,
} from './common-druckdaten.mapper';

export function mapEUBP(
  state: IAppState,
  sparteDruckdaten: SparteDruckdaten,
): DokumentenErstellungRequestModel<EuBPDruckdaten> {
  const euBP = mapInfopaket(state, sparteDruckdaten);
  euBP.dokumentDruckdaten.dokument = BffDokument.EUBP;
  euBP.dokumentDruckdaten.personId = state.kdv.perId;
  return euBP;
}

export function mapInfopaket(
  state: IAppState,
  sparteDruckdaten: SparteDruckdaten,
): DokumentenErstellungRequestModel<InfopaketDruckdaten> {
  const commonInfopaketdaten: DokumentenErstellungRequestModel<InfopaketDruckdaten> = {
    antraege: mapAntraege([sparteDruckdaten]),
    sammelantragsnummer: state.sammelantragsnummer,
    bankverbindung: mapBankverbindung(state),
    vermittler: mapVermittler(state),
    versicherungsnehmer: mapVersicherungsnehmer(state),
    vertragsschlussverfahren: state.vertragsschlussverfahren,
    zahlungsmethode: {
      zahlungsart: state.zahlung.zahlungsart,
      zahlweise: state.zahlung.zahlweise,
    },
    dokumentDruckdaten: {
      dokument: BffDokument.INFOPAKET,
      uebergabeVertragsschlussverfahren: state.telefonverkauf.versandArtAVB,
      beratungDruck: mapBeratungDruck(state),
      personId: state.kdv.perId,
      programmteilnahme: getProgrammteilnahme(state.policeVersand.versandArt),
      beibehaltenData: mapBeibehaltenData(state),
    },
    tarifbereich: getTarifbereich(
      state.versicherungsnehmer,
      getBeziehungVpZumVn(state, sparteDruckdaten),
    ),
  };

  if (state.vertragsschlussverfahren === Vertragsschlussverfahren.TELEFONVERKAUF) {
    commonInfopaketdaten.dokumentDruckdaten.telefonverkauf = mapTelefonverkauf(state);
  }

  const clonedInfoPaketRequest: DokumentenErstellungRequestModel<InfopaketDruckdaten> =
    cloneDeep(commonInfopaketdaten);
  clonedInfoPaketRequest.sparteDruckdaten = addCheckoutDataToSparteDruckdaten(
    state,
    sparteDruckdaten,
  );
  return clonedInfoPaketRequest;
}

export function mapBeibehaltenData(state: IAppState): Array<BeibehaltenData> {
  return state.produkte
    .filter(produkt => produkt.beibehalten)
    .map(value => ({
      ablauf: convertDateFormatFromLocalStateToShortIso(value.ablauf),
      vorvertrag: value.vorvertragsnummer[0].vertragsnummer,
    }));
}
